// Libraries
import React from "react";
import { useModal } from "./useModal";
import Modal from "./Modal";
import vector from "../../assets/static/Icons/Vector.png";
import ellipse from "../../assets/static/Icons/ellipse.png";
import ListFilter from "../SearchPage/Utils/ListFilter";
import NeighborhoodFilter from "../SearchPage/Utils/NeighborhoodsFilter";
import RoundToggle from "../Utils/RoundToggle";
import PriceFilter from "../SearchPage/Utils/PriceFilter";
import ActiveFilters from "../SearchPage/Utils/ActiveFilters";
import FilterTypeSpace from "../SearchPage/Utils/FilterTypeSpace";
import useCurrentLanguaje from "../../services/currentlenguaje";
import globalJson from "../../utilities/traduccGlobal.json";


const Modals = ({
  allOptions,
  clickEventCustom,
  clickEventCustomTypeSpace,
  clickEventPrice,
  housingType,
  housingTypeHandle,
  spaceType,
  spaceTypeHandle,
  flexibility,
  flexibilityHandle,
  inmediateBooking,
  inmediateBookingHandle,
  filterInmediatBooking,
  handleInmediatBooking,
  petFilter,
  neighborhoods,
  neighborhoodsHandle,
  handlePetFilter,
  allGlampings,
  handleAllGlampings,
  handleHotSale,
  filterHotSale,
  reset,
}) => {
  const { handleFilterLang } = useCurrentLanguaje();

  const [isOpenModal, openModal, closeModal] = useModal(false);
  return (
    <div>
      <button className="btnIcon" onClick={openModal}>
        <img alt="Cross" className="btnIcon__Icon" src={vector} />
        {flexibility ||
        filterInmediatBooking ||
        petFilter ||
        allOptions.some((e) => e.checked) ||
        spaceType.some((e) => e.checked) ? (
          <img alt="Cross" className="btnIcon__Icon__filter" src={ellipse} />
        ) : (
          " "
        )}
      </button>
      <Modal isOpen={isOpenModal} closeModal={closeModal}>
        <ActiveFilters
          housingType={housingType}
          housingTypeHandle={housingTypeHandle}
          spaceType={spaceType}
          spaceTypeHandle={spaceTypeHandle}
          flexibility={flexibility}
          flexibilityHandle={flexibilityHandle}
          inmediateBooking={inmediateBooking}
          inmediateBookingHandle={inmediateBookingHandle}
          neighborhoods={neighborhoods}
          neighborhoodsHandle={neighborhoodsHandle}
          pets={petFilter}
          handlePetFilter={handlePetFilter}
          reset={reset}
        />
        <div className="filtersContainer">
          <ListFilter
            title=
            {handleFilterLang(globalJson).tipoDeAlohamiento}
            allOptions={allOptions}
            clickEventCustom={clickEventCustom}
          />
          <FilterTypeSpace
            spaceType={spaceType}
            clickEventCustomTypeSpace={clickEventCustomTypeSpace}
            title=
            {handleFilterLang(globalJson).tipoDeEspacio}
              
          />
          {neighborhoods.length > 0 && (
            <>
              <NeighborhoodFilter
                title=
            {handleFilterLang(globalJson).barrios}
               
                allOptions={neighborhoods}
                clickEventCustom={neighborhoodsHandle}
              />
            </>
          )}
          <PriceFilter clickEventPrice={clickEventPrice} />
          <RoundToggle
            id={"flexbility"}
            name={"flexbility"}
            value={"flexbility"}
            checked={flexibility}
            title=            {handleFilterLang(globalJson).flexibilidadCancelar}

            customClickEvent={flexibilityHandle}
          />
          <RoundToggle
            id={"inmeediatBooking"}
            name={"inmeediatBooking"}
            value={"inmeediatBooking"}
            checked={filterInmediatBooking}
            title={handleFilterLang(globalJson).reservaInmediata}
            customClickEvent={handleInmediatBooking}
          />

          {/* <RoundToggle
            id={"hotSale"}
            name={"hotSale"}
            value={"hotSale"}
            checked={filterHotSale}
            title={"Hot sale"}
            customClickEvent={handleHotSale}
          /> */}
          <RoundToggle
            id={"pets"}
            name={"pets"}
            value={"pets"}
            checked={petFilter}
            title={handleFilterLang(globalJson).mascotas1}
            customClickEvent={handlePetFilter}
          />
          <RoundToggle
            id={"allGlampings"}
            name={"allGlampings"}
            value={"allGlampings"}
            checked={allGlampings}
            title={handleFilterLang(globalJson).todosLosGlampings}
            customClickEvent={handleAllGlampings}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Modals;
